import React from 'react';
export function getContextSetter() {
  return {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  };
}
export function getJsonPropsSetter() {
  return {
    name: '_jsonProps',
    title: 'json props',
    display: 'block',
    // supportVariable: true,
    // initialValue: {},
    setter: {
      componentName: 'MixedSetter',
      props: function props() {
        return {
          setters: [window.cnLowCodeUtils.expression.getJSExpressionPrototype({
            type: 'base'
          }), 'JsonSetter']
        };
      }
    }
  };
}
export function getDepsSetter(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    isLowcode = _ref.isLowcode;
  return {
    name: '_deps',
    title: '依赖的数据',
    display: 'block',
    supportVariable: true,
    setter: function setter() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "\u8BF7\u7ED1\u5B9A\u4F9D\u8D56\u7684\u6570\u636E"), /*#__PURE__*/React.createElement("p", null, "\u5F53\u4F9D\u8D56\u7684\u6570\u636E\u53D8\u5316\u65F6\u7EC4\u4EF6\u4F1A\u5237\u65B0"), /*#__PURE__*/React.createElement("p", null, "\u652F\u6301\u4F7F\u7528\u6570\u7EC4\u6765\u7ED1\u5B9A\u591A\u4E2A\u6570\u636E"));
    }
  };
}
export function getDestroyWhenDepsChangeSetter() {
  return {
    name: '_destroryWhenDepsUpdate',
    title: '依赖的数据更新时销毁并重新渲染',
    display: 'block',
    supportVariable: true,
    setter: 'BoolSetter'
  };
}
export function parseJsonProps(_ref2) {
  var _context = _ref2._context,
    _jsonProps = _ref2._jsonProps;
  var props = _jsonProps;
  if (typeof props === 'function') {
    props = props({}, _context.state);
  }
  if (typeof props !== 'object') {
    props = {};
  }
  props = props || {};
  return props;
}